<template>
  <Form @submit="submit" :initial-values="form" :validation-schema="schema">
    <div>
      <div class="mt-5">
        <label class="text-sm text-gray-500" for="name">{{ $lang.app.BANK_NAME }} <span class="text-red-500">*</span></label>
        <Field
            id="name"
            name="name"
            type="text"
            v-model="form.name"
            class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
        />
        <ErrorMessage name="name" class="text-xs text-red-400" />
      </div>
      <div class="mt-5">
        <label class="text-sm text-gray-500" for="cardNumber">{{ $lang.app.CODE_OF_BANK_REQUISITE }}</label>
        <Field
            id="cardNumber"
            name="cardNumber"
            type="text"
            v-model="form.cardNumber"
            class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
        />
        <ErrorMessage name="cardNumber" class="text-xs text-red-400"/>
      </div>
      <div class="mt-5">
        <label class="text-sm text-gray-500" for="inn">{{ $lang.app.INN_PIN }}</label>
        <Field
            id="inn"
            name="inn"
            type="text"
            v-model="form.inn"
            class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
        />
        <ErrorMessage name="inn" class="text-xs text-red-400" />
      </div>
      <div class="mt-5">
        <label class="text-sm text-gray-500" for="bik">{{ $lang.app.BIK }} <span class="text-red-500">*</span></label>
        <Field
            id="bik"
            name="bik"
            type="text"
            v-model="form.bik"
            class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
        />
        <ErrorMessage name="bik" class="text-xs text-red-400" />
      </div>
      <div class="mt-5">
        <label class="text-sm text-gray-500" for="taxAuthorityCode">{{ $lang.app.TAX_AUTHORITY_CODE }} <span class="text-red-500">*</span></label>
        <Field
            id="taxAuthorityCode"
            name="taxAuthorityCode"
            type="text"
            v-model="form.taxAuthorityCode"
            placeholder="001"
            class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
        />
        <ErrorMessage name="taxAuthorityCode" class="text-xs text-red-400" />
      </div>
      <div class="mt-5">
        <label class="text-sm text-gray-500" for="taxAuthorityDistrict">{{ $lang.app.TAX_AUTHORITY_DISTRICT }} <span class="text-red-500">*</span></label>
        <Field
            id="taxAuthorityDistrict"
            name="taxAuthorityDistrict"
            type="text"
            v-model="form.taxAuthorityDistrict"
            placeholder="УГНС по Октябрьскому району"
            class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
        />
        <ErrorMessage name="taxAuthorityDistrict" class="text-xs text-red-400" />
      </div>
<!--      <div v-if="userType === userTypesGetValue('LEGAL_ENTITY')" class="mt-5">-->
<!--        <label class="text-sm text-gray-500" for="kkn">{{ $lang.app.UGNS_KKN }} :</label>-->
<!--        <Field-->
<!--            id="kkn"-->
<!--            name="kkn"-->
<!--            type="text"-->
<!--            v-model="form.kkn"-->
<!--            class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"-->
<!--        />-->
<!--        <ErrorMessage name="kkn" class="text-xs text-red-400" />-->
<!--      </div>-->
      <div class="mt-5">
        <label class="text-sm text-gray-500" for="paymentAccount">
          {{ userType === userTypesGetValue('LEGAL_ENTITY') ? $lang.app.MAIN_BANK_ACCOUNT : $lang.app.ACCOUNT_NUMBER }}</label>
        <Field
            id="paymentAccount"
            name="paymentAccount"
            type="text"
            v-model="form.paymentAccount"
            class="w-full mt-2 border-gray-200 rounded-md focus:border-indigo-600 focus:ring focus:ring-opacity-40 focus:ring-indigo-500"
        />
        <ErrorMessage name="paymentAccount" class="text-xs text-red-400"/>
      </div>
      <div class="mt-5">
        <label class="text-sm text-gray-500">{{ $lang.app.ATTACH_CONFIRMATION_DOCUMENT }}</label>
        <div v-if="form.filename" class="mt-2 text-blue-400 font-medium flex items-center">
          <span class="mr-4">{{ form.filename }}</span>
          <button type="button" @click.prevent="removeFile"><XIcon class="text-red-400 w-5 h-5"/></button>
        </div>
        <div v-else class="mt-2">
          <div class="w-full">
            <Field type="file" :name="`filesDemo`" accept="application/pdf"
                   @change="event => form.filesDemo = event.target.files[0]"/>
          </div>
          <ErrorMessage :name="`filesDemo`" class="text-xs text-red-400"/>
        </div>
      </div>
    </div>

    <div class="mt-5 flex justify-end">
      <button type="submit"
              class="relative px-4 py-2 text-sm text-center text-white bg-green-500 rounded-md focus:outline-none hover:bg-green-400"
              :disabled="submitting">
        {{ $lang.app.SAVE }}
        <div v-if="submitting" class="absolute z-10 rounded w-full h-full top-0 left-0 bg-green-500 flex items-center justify-center">
          <div class="block animate-spin">
            <RefreshIcon class="w-6 h-6 mirror-y"/>
          </div>
        </div>
      </button>
    </div>

  </Form>
</template>
<script>
import { Form, Field, ErrorMessage } from "vee-validate";
import * as yup from "yup";
import userApi from "../../../../api/users";
import {getValueByKey as userTypesGetValue} from "../../../../helpers/constants/userTypes";
import fileUploadMixin from "../../../../mixins/fileUploadMixin";

export default {
  props: {
    profileId: Number,
    userType: Number,
    bankDetail: Object,
  },
  components: {
    Form, Field, ErrorMessage,
  },
  mixins: [fileUploadMixin],
  data() {
    return {
      submitting: false,

      form: {
        name: this.bankDetail?.name,
        cardNumber: this.bankDetail?.cardNumber,
        inn: this.bankDetail?.inn,
        bik: this.bankDetail?.bik,
        taxAuthorityCode: this.bankDetail?.taxAuthorityCode,
        taxAuthorityDistrict: this.bankDetail?.taxAuthorityDistrict,
        // kkn: this.bankDetail?.kkn,
        paymentAccount: this.bankDetail?.paymentAccount,
        files: this.bankDetail?.files?.id,
        filename: this.bankDetail?.files?.filename,
        filesDemo: null,
      },
      schema: yup.object({
        // cardNumber: yup.string().required(),
        // inn: yup.string().required(),
        bik: yup.string().required(),
        taxAuthorityCode: yup.string().max(4).required(),
        taxAuthorityDistrict: yup.string().required(),
        name: yup.string().required(),
      }),
    }
  },
  methods: {
    userTypesGetValue,
    removeFile() {
      this.form.files = null
      this.form.filename = null
    },
    prepareFilesForSubmit() {
      if(this.form.filesDemo) {
        return new Promise((resolve, reject) => {
          this.uploadFile(this.form.filesDemo).then((res) => {
            this.form.files = res
            resolve(res)
          }).catch(error => {
            this.$snotify.error(error)

            reject(error)
          });
        })
      }
    },
    submit(values, actions) {
      if(!this.bankDetail) {
        this.createBankDetail(values, actions)
      } else {
        this.editBankDetail(values, actions)
      }
    },
    async createBankDetail(values, actions) {
      this.submitting = true
      await this.prepareFilesForSubmit()
      userApi.storeBankDetail(this.profileId, {
        name: this.form.name,
        cardNumber: this.form.cardNumber,
        inn: this.form.inn,
        bik: this.form.bik,
        taxAuthorityCode: this.form.taxAuthorityCode,
        taxAuthorityDistrict: this.form.taxAuthorityDistrict,
        paymentAccount: this.form.paymentAccount,
        files: this.form.files,
      })
          .then(() => {
            this.$emitter.emit('refresh-profile')
          }).catch(error => {
        if (error.response.data.status === 422) {
          this.setValidationErrors(actions, error.response.data.errors)
        } else {
          this.$snotify.error(error)
        }
      }).finally(() => {
        this.submitting = false
      })
    },
    async editBankDetail(values, actions) {
      this.submitting = true
      await this.prepareFilesForSubmit()
      userApi.updateBankDetail(this.profileId, this.bankDetail.id, {
        name: this.form.name,
        cardNumber: this.form.cardNumber,
        inn: this.form.inn,
        bik: this.form.bik,
        taxAuthorityCode: this.form.taxAuthorityCode,
        taxAuthorityDistrict: this.form.taxAuthorityDistrict,
        paymentAccount: this.form.paymentAccount,
        files: this.form.files,
      })
          .then(() => {
            this.$emitter.emit('refresh-profile')
          }).catch(error => {
        if (error.response.data.status === 422) {
          this.setValidationErrors(actions, error.response.data.errors)
        } else {
          this.$snotify.error(error)
        }
      }).finally(() => {
        this.submitting = false
      })
    }
  }
}
</script>
